import { Link } from "react-router-dom";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { Button } from "@/components/primitives/Button";

export default function Register() {
	return (
		<AuthLayout
			title="Registrierung nur per Einladung"
			subtitle="Kartenwerk ist einladungspflichtig. Ohne Link vom Admin kannst du kein Konto anlegen."
		>
			<p className="text-sm text-fg-muted">
				Hast du eine Einladung? Öffne den vollständigen Link — er sieht etwa so aus:{" "}
				<code className="font-mono text-xs">/accept/…</code>
			</p>
			<div className="mt-6 flex flex-col gap-3">
				<Button as="a" href="/login">
					Zur Anmeldung
				</Button>
				<p className="text-sm text-fg-muted">
					Zurück zur{" "}
					<Link
						className="font-medium text-teal-600 hover:underline dark:text-teal-400"
						to="/"
					>
						Startseite
					</Link>
				</p>
			</div>
		</AuthLayout>
	);
}
